import unqualifiedItems from './unqualified-items';

function transformUnqualifiedItems(qualificationProfile = {}) {
  return unqualifiedItems.filter((qualification) => {
    if (!Object.prototype.hasOwnProperty.call(qualificationProfile, qualification.key)) {
      return false;
    }

    if (qualification.key === 'unqualified_segments') {
      return !!qualificationProfile.unqualified_segments.length;
    }

    if (qualification.key === 'has_purchase_invoice' && !!qualificationProfile.is_manufacturer) {
      return false;
    }

    return !qualificationProfile[qualification.key];
  });
}

export default transformUnqualifiedItems;
